import { createSelector } from '@reduxjs/toolkit';
import { selectBulk } from '../selectors';
import { BulkState } from '../types';

export const selectEmail = createSelector(selectBulk, (bulkState: BulkState) => bulkState.email);
